import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { canEditPetition, Loading, petitionSlugCanonicalRedirect } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'starter-start-strong',
		path: '/p/:slug/start-strong',
		beforeServerRender: petitionSlugCanonicalRedirect,
		component: loadable(async () => import(/* webpackChunkName: "pages/starter-startStrong" */ './index'), {
			exportName: 'StartStrong',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: canEditPetition('slug'),
		},
		frame: {
			footer: false,
			header: true,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
